module.exports = require('./helpers/bundle-url').getBundleURL('Fa2tF') + "loader.c8b9d995.gif";